/**
 * Include your custom JavaScript here.
 *
 * Live search (header autocomplete) with 400ms debounce.
 */
(function () {
  var DEBOUNCE_MS = 400;
  var MIN_CHARS = 1;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function formatMoney(price) {
    if (price == null || price === '') return '';
    // Predictive Search JSON returns major-unit decimals ("34.95"), not cents.
    var amount = parseFloat(String(price).replace(',', '.'));
    if (!isFinite(amount)) return '';
    var formatted = amount.toFixed(2);
    var format = (window.theme && window.theme.moneyFormat) || '{{ amount }}€';
    if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(format)) {
      return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted.replace('.', ','));
    }
    if (/\{\{\s*amount\s*\}\}/.test(format)) {
      return format.replace(/\{\{\s*amount\s*\}\}/, formatted);
    }
    return formatted + '€';
  }

  function productImage(product) {
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.image) return product.image;
    return '';
  }

  function initLiveSearch(root) {
    var form = root.querySelector('[data-live-search]');
    var input = root.querySelector('[data-live-search-input]');
    var panel = root.querySelector('[data-live-search-panel]');
    if (!form || !input || !panel) return;

    var timer = null;
    var abortController = null;
    var lastQuery = '';

    function closePanel() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function openPanel(html) {
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function render(query, data) {
      var results = (data && data.resources && data.resources.results) || {};
      var queries = results.queries || [];
      var products = results.products || [];
      var searchUrl = '/search?q=' + encodeURIComponent(query);

      if (!queries.length && !products.length) {
        openPanel(
          '<p class="Header__LiveSearchEmpty">Aucun résultat pour « ' +
            escapeHtml(query) +
            ' »</p>' +
            '<a class="Header__LiveSearchAll" href="' +
            searchUrl +
            '">Voir tous les résultats</a>'
        );
        return;
      }

      var html = '';

      if (queries.length) {
        html += '<div class="Header__LiveSearchGroup"><p class="Header__LiveSearchLabel">Suggestions</p>';
        queries.slice(0, 4).forEach(function (item) {
          var href = item.url || '/search?q=' + encodeURIComponent(item.text || query);
          html +=
            '<a class="Header__LiveSearchLink" href="' +
            escapeHtml(href) +
            '"><span class="Header__LiveSearchTitle">' +
            escapeHtml(item.text || '') +
            '</span></a>';
        });
        html += '</div>';
      }

      if (products.length) {
        html += '<div class="Header__LiveSearchGroup"><p class="Header__LiveSearchLabel">Produits</p>';
        products.slice(0, 6).forEach(function (product) {
          var img = productImage(product);
          var price = formatMoney(product.price_min || product.price);
          html +=
            '<a class="Header__LiveSearchLink" href="' +
            escapeHtml(product.url || '#') +
            '">' +
            (img
              ? '<img class="Header__LiveSearchThumb" src="' +
                escapeHtml(img) +
                '" alt="' +
                escapeHtml(product.title || '') +
                '" width="48" height="48" loading="lazy">'
              : '<span class="Header__LiveSearchThumb"></span>') +
            '<span class="Header__LiveSearchMeta"><span class="Header__LiveSearchTitle">' +
            escapeHtml(product.title || '') +
            '</span>' +
            (price ? '<span class="Header__LiveSearchPrice">' + escapeHtml(price) + '</span>' : '') +
            '</span></a>';
        });
        html += '</div>';
      }

      html += '<a class="Header__LiveSearchAll" href="' + searchUrl + '">Voir tous les résultats</a>';
      openPanel(html);
    }

    function fetchResults(query) {
      if (abortController) abortController.abort();
      abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=query,product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: abortController ? abortController.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) throw new Error('search failed');
          return response.json();
        })
        .then(function (data) {
          if (input.value.trim() !== query) return;
          render(query, data);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(timer);

      if (query.length < MIN_CHARS) {
        lastQuery = '';
        closePanel();
        return;
      }

      if (query === lastQuery) return;

      openPanel('<p class="Header__LiveSearchHint">Recherche…</p>');
      timer = window.setTimeout(function () {
        lastQuery = query;
        fetchResults(query);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      var query = input.value.trim();
      if (query.length >= MIN_CHARS && panel.innerHTML) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanel();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.Header__SearchWrap').forEach(initLiveSearch);
  });
})();

/**
 * Product rating score from Trustoo.
 *
 * Trustoo injects stars and a review count. The average lives on the widget as
 * a `rating` attribute; we surface it next to the stars. Store-wide 4,8/5 is
 * for marketing copy only — not these widgets.
 */
(function () {
  var CARD_SELECTOR = '.ProductItem__Info .collection-icon-list';
  var PDP_SELECTOR = '.ProductMeta .product-icon-list, .Product__Info .product-icon-list';
  var scheduled = false;

  function parseReviewCount(widget) {
    var attr = widget.getAttribute('data-review-num');
    if (attr !== null && String(attr).trim() !== '') {
      var fromAttr = parseInt(attr, 10);
      if (!isNaN(fromAttr)) return fromAttr;
    }

    var textEl = widget.querySelector('.tt-rating-text');
    if (!textEl) return null;

    var digits = (textEl.textContent || '').match(/\d+/);
    if (!digits) return null;
    return parseInt(digits[0], 10);
  }

  function hideZeroReviews(widget) {
    var count = parseReviewCount(widget);
    if (count !== 0) {
      widget.classList.remove('is-zero-reviews');
      return;
    }
    widget.classList.add('is-zero-reviews');
  }

  function addScore(widget) {
    if (widget.classList.contains('is-zero-reviews')) return false;

    var score = parseFloat(widget.getAttribute('rating'));
    if (isNaN(score) || score <= 0) return false;

    var formatted = score.toFixed(1).replace('.', ',');
    var grew = false;
    var value = widget.querySelector('.ProductItem__RatingValue');
    if (!value) {
      grew = true;
      value = document.createElement('span');
      value.className = 'ProductItem__RatingValue';
      var count = widget.querySelector('.tt-rating-text');
      if (count) widget.insertBefore(value, count);
      else widget.appendChild(value);
    }
    value.textContent = formatted;

    return grew;
  }

  function hideEmptyTrustooBlock() {
    var wrap = document.getElementById('trustoo-widget-wrapper');
    if (!wrap) return;

    var empty = wrap.querySelector('.noreviews-text, .noreviews-center');
    if (empty) wrap.classList.add('is-zero-reviews');
    else wrap.classList.remove('is-zero-reviews');
  }

  /**
   * Carousels lock their viewport height when they initialise, which happens before the rating
   * widgets exist. Without a re-measure the extra line pushes the price out of the clipped
   * viewport and it disappears.
   */
  function remeasureProductCarousels() {
    if (typeof window.Flickity === 'undefined') return;

    document.querySelectorAll('.flickity-enabled').forEach(function (carousel) {
      if (!carousel.querySelector('.ProductItem')) return;
      var instance = window.Flickity.data(carousel);
      if (instance) instance.resize();
    });
  }

  function addScores() {
    scheduled = false;

    document.querySelectorAll(CARD_SELECTOR + ', ' + PDP_SELECTOR).forEach(hideZeroReviews);

    var grew = false;
    document.querySelectorAll(CARD_SELECTOR + ', ' + PDP_SELECTOR).forEach(function (widget) {
      if (addScore(widget)) grew = true;
    });

    hideEmptyTrustooBlock();

    if (grew) remeasureProductCarousels();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(addScores);
  }

  document.addEventListener('DOMContentLoaded', function () {
    addScores();
    // Widgets arrive after the app script runs; the rating attribute is often set
    // on an already-inserted node, so we also watch attributes.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['rating', 'data-review-num']
    });
  });
})();

/**
 * Wishlist Swym.
 *
 * Swym injects its own header anchor (#swym-advanced-header-icon) and attaches the handler that
 * runs the consent check before opening the wishlist panel. Its placement selectors only match
 * Dawn-style themes, so here it lands inside the cart list item and renders at 0x0. Rather than
 * reimplementing its logic, the header button forwards its click to that anchor. The lookup
 * happens on click because Swym injects late.
 */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-swym-wishlist-trigger]');
    if (!trigger) return;

    event.preventDefault();

    var swymIcon = document.getElementById('swym-advanced-header-icon');
    if (swymIcon) {
      swymIcon.click();
      return;
    }

    // Swym not loaded yet (or app removed): open the panel directly when it is available.
    if (window.SwymGhostWishlistDrawer) window.SwymGhostWishlistDrawer.open();
  });
})();

/**
 * Wishlist hearts on product cards.
 *
 * Swym's collections extension ships selectors for Shopify's Horizon theme (`product-list`,
 * `.product-card`), which match nothing here, so it injects no heart at all. Its config is
 * assigned by an inline app snippet while the page parses, and its injector is a deferred
 * script placed after this file, so the selectors can be corrected in between.
 *
 * Swym currently emits invalid JS when social proof is unset (`socialCountEnabled: ,`), so the
 * whole config assignment throws and hearts never inject. Repair that snippet before the
 * deferred injector runs, then point the selectors at Prestige's `.ProductItem` cards.
 */
(function () {
  function patchConfig(config) {
    if (!config) return;
    config.AttachButtonSelector = '.ProductItem';
    // Resolved with tile.querySelector(), so it must stay relative to the card.
    config.ProductUrlSelector = 'a[href*="/products/"]';
    // Its own placement maths measures the tile image and lands roughly 130px past the card edge
    // here. The heart is anchored on the image wrapper instead.
    config.shouldCalculatePosition = false;
    config.buttonWidth = 28;
    config.buttonHeight = 28;
    if (typeof config.socialCountEnabled === 'undefined' || config.socialCountEnabled === '') {
      config.socialCountEnabled = false;
    }
  }

  function repairBrokenSwymConfig() {
    if (window.SwymAdvancedCollectionsWishlistConfig && window.SwymAdvancedCollectionsWishlistConfig.beforeHtml) {
      return true;
    }

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var script = scripts[i];
      if (script.src) continue;
      var text = script.textContent || '';
      if (text.indexOf('window.SwymAdvancedCollectionsWishlistConfig') === -1) continue;
      if (text.indexOf('beforeHtml') === -1) continue;

      var fixed = text.replace(/socialCountEnabled:\s*,/g, 'socialCountEnabled: false,');

      try {
        (0, eval)(fixed);
      } catch (err) {
        return false;
      }
      return !!window.SwymAdvancedCollectionsWishlistConfig;
    }
    return false;
  }

  repairBrokenSwymConfig();
  patchConfig(window.SwymAdvancedCollectionsWishlistConfig);
})();

(function () {
  var scheduled = false;
  var observer = null;

  function pinHeart(container) {
    var card = container.closest('.ProductItem');
    if (!card) return;

    var image = card.querySelector('.ProductItem__Wrapper') || card.querySelector('.ProductItem__ImageWrapper');
    if (image && container.parentNode !== image) image.appendChild(container);

    ['top', 'right', 'left', 'bottom', 'transform', 'width', 'height', 'margin', 'inset'].forEach(function (prop) {
      container.style.removeProperty(prop);
    });

    var button = container.querySelector('.swym-advanced-wishlist-collections');
    if (button) button.style.removeProperty('transform');
  }

  function pinAll() {
    scheduled = false;
    document.querySelectorAll('.ProductItem .swym-advanced-wishlist-collections-container').forEach(pinHeart);
  }

  function schedulePin() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(pinAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinAll);
  else pinAll();

  // Debounced: Swym injects many nodes; avoid layout thrash on every mutation.
  observer = new MutationObserver(schedulePin);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/**
 * Wishlist heart on the product page.
 *
 * Swym's button lives in its app block at the bottom of the page. It is moved next to the
 * add-to-cart button; Swym still fills it by id afterwards.
 *
 * Kaching Bundles injects <kaching-bundle> as a sibling of the ATC button. Once the heart
 * wrapper exists, that sibling lands inside the flex row and the ATC stretches beside the
 * widget. Keep the bundle on its own row, under the button.
 */
(function () {
  // PDP-only: skip on homepage/collections to cut MutationObserver cost.
  if (window.theme && window.theme.template && window.theme.template !== 'product') return;

  var scheduled = false;

  function placePdpActions() {
    scheduled = false;
    var atc = document.querySelector('.ProductForm .ProductForm__AddToCart');
    if (!atc) return;

    var row = atc.closest('.ProductForm__AtcRow');
    if (!row) {
      row = document.createElement('div');
      row.className = 'ProductForm__AtcRow';
      atc.parentNode.insertBefore(row, atc);
      row.appendChild(atc);
    }

    var button = document.getElementById('swym-custom-pdp-button');
    if (button && button.parentNode !== row) row.appendChild(button);

    var form = atc.closest('.ProductForm') || row.parentNode;
    if (!form) return;

    var bundle = form.querySelector('kaching-bundle');
    if (bundle && bundle.previousElementSibling !== row) {
      row.parentNode.insertBefore(bundle, row.nextSibling);
    }
  }

  function schedulePlace() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(placePdpActions);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placePdpActions);
  else placePdpActions();

  setTimeout(placePdpActions, 100);
  setTimeout(placePdpActions, 600);
  setTimeout(placePdpActions, 1500);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(schedulePlace).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/**
 * Header wishlist count. Swym keeps the real list; this badge mirrors it so the mobile
 * heart can show how many products are saved.
 */
(function () {
  var badgeSelector = '[data-swym-wishlist-count]';

  function setCount(count) {
    var value = parseInt(count, 10);
    if (isNaN(value) || value < 0) value = 0;

    document.querySelectorAll(badgeSelector).forEach(function (badge) {
      badge.textContent = value;
      if (value > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    });
  }

  function countFromSwat(swat) {
    if (!swat) return;

    if (typeof swat.fetch === 'function') {
      swat.fetch(function (products) {
        setCount((products || []).length);
      });
      return;
    }

    if (typeof swat.getWishlist === 'function') {
      swat.getWishlist(function (products) {
        setCount((products || []).length);
      });
    }
  }

  function bindSwat(swat) {
    countFromSwat(swat);

    var events = swat.JSEvents || {};
    ['addedToWishlist', 'removedFromWishlist', 'fetchedWishlist', 'wishlistCountUpdated'].forEach(function (name) {
      var type = events[name] || name;
      if (swat.evtLayer && typeof swat.evtLayer.addEventListener === 'function') {
        swat.evtLayer.addEventListener(type, function () {
          countFromSwat(swat);
        });
      }
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(bindSwat);

  document.addEventListener('DOMContentLoaded', function () {
    if (window._swat) bindSwat(window._swat);

    var local = window.SwymLocalWishlist;
    if (local && typeof local.getSyncableItems === 'function') {
      setCount(local.getSyncableItems().length);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.swym-advanced-wishlist-collections, #swym-custom-pdp-button')) return;
      window.setTimeout(function () {
        if (window._swat) countFromSwat(window._swat);
      }, 500);
    });

    var swymIcon = document.getElementById('swym-advanced-header-icon');
    if (!swymIcon || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function () {
      var text = (swymIcon.textContent || '').replace(/[^\d]/g, '');
      if (text !== '') setCount(text);
    }).observe(swymIcon, { childList: true, subtree: true, characterData: true });
  });
})();

/**
 * Welcome popup → Klaviyo.
 * The Shopify customer form still creates the subscriber; this also identifies
 * the email in Klaviyo immediately so the Welcome Series can start without
 * waiting for the Shopify sync. If Klaviyo's own popup appears, the theme
 * popup is hidden to avoid two overlays.
 */
(function () {
  function isKlaviyoPopup(node) {
    if (!node || node.nodeType !== 1) return false;
    var cls = node.className && String(node.className);
    if (!cls) return false;
    return cls.indexOf('kl-private-reset-css') !== -1 || cls.indexOf('klaviyo-form') !== -1;
  }

  function hideThemePopup() {
    var popup = document.querySelector('.NewsletterPopup');
    if (popup) popup.setAttribute('aria-hidden', 'true');
  }

  function identifyKlaviyo(email) {
    if (!email) return;
    var payload = { $email: email, email: email };
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', payload]);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['identify', payload]);
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      window.klaviyo.identify(payload);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.id) return;
    if (form.id !== 'newsletter-popup' && form.id !== 'footer-newsletter') return;
    var input = form.querySelector('input[type="email"]');
    if (input && input.value) identifyKlaviyo(input.value.trim());
  }, true);

  if (typeof MutationObserver === 'undefined') return;

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (isKlaviyoPopup(added[j]) || (added[j].querySelector && added[j].querySelector('[class*="kl-private-reset-css"], .klaviyo-form'))) {
          hideThemePopup();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/**
 * Prestige stagger: cards start visibility:hidden, then TimelineLite +
 * IntersectionObserver reveal them (autoAlpha). Do not force-show early —
 * that causes a flash then re-animate. Only unstick viewport cards that
 * GSAP never touched (theme section failed to init).
 */
(function () {
  function nearViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh && rect.bottom > 0;
  }

  function revealStuckCards() {
    var cards = document.querySelectorAll('.ProductList--grid .ProductItem');
    for (var i = 0; i < cards.length; i++) {
      var el = cards[i];
      if (!nearViewport(el)) continue;
      // GSAP already owns this card (mid or done animation)
      if (el.style.opacity !== '' || el.style.transform !== '') continue;
      if (window.getComputedStyle(el).visibility !== 'hidden') continue;
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    }
  }

  function schedule() {
    setTimeout(revealStuckCards, 2500);
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
})();

/**
 * Collection sort — desktop select + mobile sheet.
 */
(function () {
  function applySort(value) {
    if (!value) return;
    var url;
    try {
      url = new URL(window.location.href);
    } catch (err) {
      return;
    }
    url.searchParams.set('sort_by', value);
    window.location.assign(url.toString());
  }

  function sortSheet() {
    return document.getElementById('da-sort-sheet');
  }

  function openSortSheet() {
    var sheet = sortSheet();
    if (!sheet) return;
    sheet.hidden = false;
    document.documentElement.classList.add('no-scroll');
  }

  function closeSortSheet() {
    var sheet = sortSheet();
    if (!sheet) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('no-scroll');
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-collection-sort]');
    if (!select) return;
    applySort(select.value);
  });

  document.addEventListener('click', function (event) {
    var open = event.target.closest && event.target.closest('[data-da-sort-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      openSortSheet();
      return;
    }

    var option = event.target.closest && event.target.closest('[data-da-sort]');
    if (option) {
      event.preventDefault();
      applySort(option.getAttribute('data-da-sort'));
      return;
    }

    if (event.target.closest && event.target.closest('[data-da-sort-close]')) {
      event.preventDefault();
      closeSortSheet();
    }
  }, true);
})();

/**
 * Collection tag filters.
 *
 * Prestige's toggle-tag handler expects each button to sit inside .Collapsible and
 * to be the event target. Our chip UI is neither, so clicks were crashing silently.
 *
 * Dedicated collections (ex. /collections/famille-floral) count as the matching
 * filter already selected.
 */
(function () {
  function filterMeta() {
    var root = document.querySelector('.DaFilter');
    return {
      all: (root && root.getAttribute('data-da-all')) || '/collections/all',
      implied: (root && root.getAttribute('data-da-implied')) || '',
      collections: ((root && root.getAttribute('data-da-collections')) || '').split(',').filter(Boolean)
    };
  }

  function collectionParts() {
    var path = window.location.pathname.replace(/\/$/, '');
    var match = path.match(/^\/collections\/([^/]+)(?:\/(.*))?$/);
    if (!match) return null;

    var meta = filterMeta();
    var handle = match[1];
    var tags = match[2] ? decodeURIComponent(match[2]).split('+').filter(Boolean) : [];

    if (meta.implied && handle === meta.implied && tags.indexOf(meta.implied) === -1) {
      tags.unshift(meta.implied);
    }

    return { tags: tags, meta: meta };
  }

  function filterUrl(tags, meta) {
    var query = window.location.search || '';
    if (!tags.length) return meta.all + query;
    if (tags.length === 1 && meta.collections.indexOf(tags[0]) !== -1) {
      return '/collections/' + tags[0] + query;
    }
    return meta.all + '/' + tags.join('+') + query;
  }

  document.addEventListener('click', function (event) {
    var reset = event.target.closest && event.target.closest('[data-action="reset-tags"]');
    if (reset && document.querySelector('.DaFilter')) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.assign(filterMeta().all + (window.location.search || ''));
      return;
    }

    var btn = event.target.closest && event.target.closest('[data-action="toggle-tag"]');
    if (!btn) return;

    var tag = btn.getAttribute('data-tag');
    var parts = collectionParts();
    if (!tag || !parts) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var tags = parts.tags.slice();
    var group = btn.closest('.DaFilter__Group, .DaFilter__Acc, .Collapsible');
    var index = tags.indexOf(tag);

    if (index !== -1) {
      tags.splice(index, 1);
    } else {
      if (group) {
        var groupTags = [];
        group.querySelectorAll('[data-tag]').forEach(function (el) {
          var value = el.getAttribute('data-tag');
          if (value) groupTags.push(value);
        });
        tags = tags.filter(function (item) {
          return groupTags.indexOf(item) === -1;
        });
      }
      tags.push(tag);
    }

    window.location.assign(filterUrl(tags, parts.meta));
  }, true);
})();

/**
 * Mobile filter drawer — open if Prestige's listener does not.
 */
(function () {
  function openFilterDrawer() {
    var drawer = document.getElementById('collection-filter-drawer');
    if (!drawer || drawer.getAttribute('aria-hidden') === 'false') return;

    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.addEventListener('click', closeFilterDrawer, { once: true });
    }
  }

  function closeFilterDrawer() {
    var drawer = document.getElementById('collection-filter-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.remove('is-visible');
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest && event.target.closest('[data-action="open-drawer"][data-drawer-id="collection-filter-drawer"]');
    if (openBtn) {
      window.setTimeout(openFilterDrawer, 50);
      return;
    }

    var closeBtn = event.target.closest && event.target.closest('[data-action="close-drawer"][data-drawer-id="collection-filter-drawer"]');
    if (closeBtn) {
      window.setTimeout(function () {
        var drawer = document.getElementById('collection-filter-drawer');
        if (drawer && drawer.getAttribute('aria-hidden') !== 'true') closeFilterDrawer();
      }, 50);
    }
  });
})();

/**
 * KaChing cart — agrandir la croix de fermeture sur mobile, sans changer son ancrage
 * (position:absolute; right — coin haut droit du header).
 */
(function () {
  if (document.getElementById('da-kaching-close-size')) return;
  var style = document.createElement('style');
  style.id = 'da-kaching-close-size';
  style.textContent = [
    '@media (max-width: 760px) {',
    '  #kaching-cart .kaching-cart__header .kaching-cart__close {',
    '    position: absolute !important;',
    '    right: var(--header-padding-x, 12px) !important;',
    '    left: auto !important;',
    '    top: 50% !important;',
    '    transform: translateY(-50%);',
    '    width: 44px !important;',
    '    height: 44px !important;',
    '    min-width: 44px !important;',
    '    min-height: 44px !important;',
    '    display: flex !important;',
    '    align-items: center !important;',
    '    justify-content: center !important;',
    '    padding: 0 !important;',
    '    touch-action: manipulation;',
    '  }',
    '  #kaching-cart .kaching-cart__header .kaching-cart__close > svg {',
    '    width: 22px !important;',
    '    height: 22px !important;',
    '    min-width: 22px !important;',
    '    min-height: 22px !important;',
    '    stroke-width: 2.25 !important;',
    '  }',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(style);
})();

